import { Buffer } from "buffer";
import ReactDOM from "react-dom";
import { LiffProvider } from "react-liff";
import App from "./App";
import "./index.css";
import { CONFIG } from "./jsx/utils/config";
window.global = window;
window.Buffer = Buffer;
const liffId = CONFIG.LIFF_ID;

const MyApp = () => {
  const isLargeScreen = window.innerWidth > 600;
  if (isLargeScreen) {
    return <App />;
  } else {
    return (
      //temp hide liff page
      <LiffProvider liffId={liffId}>
        <App />
      </LiffProvider>
    );
  }
};

ReactDOM.render(<MyApp />, document.getElementById("root"));
